//Importacion del history de Vue Router
import { createRouter, createWebHistory } from "vue-router";
//#############################################################
//Importaciones de Rutas, vistas/views BUTTONS NAVBAR
import RodasepHome from "../views/RodasepHome.vue"; //Inicio BUTTON1
import RodasepProductos from "@/views/RodasepProductos.vue"; //Productos BUTTON2
//#############################################################
//Rodamientos▼ Dropdown Menu BUTTON3
import RodamientoAgricola from "@/views/RodamientoAgricola.vue";
import RodamientoAutomotriz from "@/views/RodamientoAutomotriz.vue";
import RoamientoIndustrial from "@/views/RoamientoIndustrial.vue";
//#############################################################
//import RodasepServicios from "@/views/RodasepServicios.vue"; // ASLEEP
//#############################################################
//Locales▼ Dropdown Menu BUTTON4
import LocalCurico from "@/views/LocalCurico.vue";
import LocalLinares from "@/views/LocalLinares.vue";
import LocalTalca from "@/views/LocalTalca.vue";
//#############################################################
import RodasepContactos from "../views/RodasepContactos.vue"; //Contactos BUTTON5
import RodasepNosotros from "@/views/RodasepNosotros.vue"; //Nosotros BUTTON6

//Rutas para todas las vistas creadas ahora y a futuro
const routes = [
  {
    path: "/", // Ruta: Inicio
    name: "RodasepHome",
    component: RodasepHome,
  },
  {
    path: "/productos", // RutaWeb: Productos
    name: "RodasepProductos",
    component: RodasepProductos,
  },
  {
    path: "/agricola", // RutaWeb: Rodamientos agricolas
    name: "RodamientoAgricola",
    component: RodamientoAgricola,
  },
  {
    path: "/automotriz", // RutaWeb: Rodamientos automotrices
    name: "RodamientoAutomotriz",
    component: RodamientoAutomotriz,
  },
  {
    path: "/industrial", // RutaWeb: Rodamientos industriales
    name: "RoamientoIndustrial",
    component: RoamientoIndustrial,
  },
  /* {
    path: "/servicios", // RutaWeb: Servicios
    name: "RodasepServicios",
    component: RodasepServicios,
  },*/
  {
    path: "/contactos", // RutaWeb: Contactos
    name: "RodasepContactos",
    component: RodasepContactos,
  },
  {
    path: "/nosotros", // RutaWeb: Nosotros
    name: "RodasepNosotros",
    component: RodasepNosotros,
  },
  {
    path: "/talca", // RutaWeb: Locales
    name: "LocalTalca",
    component: LocalTalca,
  },
  {
    path: "/curico", // RutaWeb: Locales
    name: "LocalCurico",
    component: LocalCurico,
  },
  {
    path: "/linares", // RutaWeb: Locales
    name: "LocalLinares",
    component: LocalLinares,
  },

  // Puedes agregar aquí otras rutas en el futuro...
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
